module.exports = __webpack_public_path__ + "assets/img/block-left-2d47bffa.png";